import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams, useNavigate, useSearchParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";
import {exportCSV} from "../../utils/helper";
import {statusColor} from "../../assets/utils/statusColors";
import { selectStoredPermissions } from '../../stores/permissionsSlice';
import moment from 'moment';


const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [isExporting, setIsExporting] = useState(false);
    const [orders, setOrders] = useState([]);
    const [branches, setBranches] = useState([]);
    const [pagination, setPagination] = useState({});
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const { type } = useParams(); 
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
   // Initialize state from URL params
    const [apiData, setApiData] = useState({
        search: searchParams.get('search') || "",
        status: searchParams.get('status') || "",
        type: searchParams.get('type') || "",
        is_export: searchParams.get('is_export') || false,
        branch_id: searchParams.get('branch_id') || "",
        payment_method: searchParams.get('payment_method') || "",
        order_from: searchParams.get('order_from') || "",
        daterange: searchParams.get('daterange') ? 
            JSON.parse(searchParams.get('daterange')).map(d => d ? new Date(d) : null) : [null, null],
        page: parseInt(searchParams.get('page')) || 1,
    });

    // Update URL when filters change
    useEffect(() => {
        const params = new URLSearchParams();
        if (apiData.search) params.set('search', apiData.search);
        if (apiData.status) params.set('status', apiData.status);
        if (apiData.is_export) params.set('is_export', apiData.is_export);
        if (apiData.type) params.set('type', apiData.type);
        if (apiData.branch_id) params.set('branch_id', apiData.branch_id);
        if (apiData.payment_method) params.set('payment_method', apiData.payment_method);
        if (apiData.order_from) params.set('order_from', apiData.order_from);
        if (apiData.daterange && apiData.daterange[0]) {
            const formattedRange = apiData.daterange.map(d => d ? moment(d).format('YYYY-MM-DD') : null);
            params.set('daterange', JSON.stringify(formattedRange));
        }
        if (apiData.page > 1) params.set('page', apiData.page.toString());
        
        navigate(`?${params.toString()}`, { replace: true });
    }, [apiData.status, apiData.search,apiData.type, apiData.order_from,apiData.payment_method,
         apiData.daterange, apiData.page,apiData.branch_id,apiData.is_export,  navigate]);

    useEffect(() => {
        getBranches();
    }, []); 

    
    useEffect(() => {
        getOrders();
    }, [apiData.page, apiData.search, apiData.daterange,apiData.type,apiData.order_from,apiData.payment_method,
        apiData.branch_id, apiData.status, apiData.is_export]); 

    const getOrders = async () => {
        try {
            if(apiData.is_export) {
                setIsExporting(true);
            } else {
                setIsLoader(true);
            }
            const payload = { ...apiData };
            if (payload.daterange && payload.daterange[0]) {
                payload.daterange = payload.daterange.map(d => d ? moment(d).format('YYYY-MM-DD') : null);
            }
            const response = await ApiService.request({
                method: "GET",
                url: "orders", // Replace with your API endpoint
                data: payload
            });
            const data = response.data;
            if(apiData.is_export){
                if(data.status && data.data && data.data.length > 0){
                    exportData(data.data, 'orders_data');
                } else {
                    toast.info("No data found to export");
                }
                setApiData({...apiData, is_export:false});
                setIsLoader(false);
                setIsExporting(false);
                return 0;
            }
            if (data.status) {
                setOrders(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
            setIsExporting(false);
        } catch (error) {
            console.error("Export Error:", error);
            setIsLoader(false);
            setIsExporting(false);
        }
       
    };

    const getBranches = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "/branches-list", // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                setBranches(data.data);
            } else {
                toast.error(data.message);
            }
        } catch (error) {
            console.log(error);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 1,
            type: '',
            status: '',
            order_from: '',
            payment_method:'', 
        });
    };

    const exportData = (data, headersMap = null) => {
        const columnsMap = {
            order_code: 'Order ID',
            branch: 'Branch',
            user: 'Customer',
            user_email: 'Email',
            user_phone: 'Phone',
            payment_method: 'Pay Method',
            type: 'Order Type',
            order_from: 'Order From',
            total_price: 'Order Amount (AED)',
            delivery_charges: 'Delivery Charges (AED)',
            vat_amount: 'VAT (AED)',
            promo_code: 'Promo Code',
            points_type: 'Loyalty',
            grand_total: 'Total Amount (AED)',
            status: 'Status',
            createdAt: 'Date',

        };
        const processedData = data.map(item => {
            const newItem = {};
            Object.keys(columnsMap).forEach(key => {
                // Format specific fields if needed
                let value = item[key];
                if ((key === 'branch' || key === 'user') && value) {
                    value = value.name;
                }
                else if (key === 'user_email') {
                    value = item['user'].email;
                }
                else if (key === 'user_phone') {
                    value = item['user'].phone;
                }
                else if (key === 'points_type' && value) {
                    value = `${value} - ${value == 'reward' ? item.loyalty_points : item.loyalty_discount}`;
                }
                else if (key === 'createdAt') {
                    value = item['createdAt'] ? moment(item['createdAt']).format('YYYY-MM-DD HH:mm:ss') : '';
                }
                
                newItem[key] = value !== undefined ? value : '';
            });
            return newItem;
        });

        exportCSV(processedData, columnsMap, 'orders_data');

    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `orders/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getOrders();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                            Orders</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Orders</li>
                        </ul>
                    </div>
                    <div className="d-flex align-orders-center gap-2 gap-lg-3">
                        {/* Add New orders Button */}
                        <button type="button" disabled={isExporting} onClick={()=> setApiData({...apiData, is_export:true})}  className='btn btn-secondary btn-sm'> 
                             {isExporting && <span className="spinner-border spinner-border-sm align-middle ms-2 me-2"></span>}
                            <i class="bi bi-upload"></i> Export
                        </button>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-3 mb-3">
                                            <div className="d-flex align-orders-center position-relative mb-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder="Search Order Id.."/>
                                            </div>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <select value={apiData.status} className='form-select' 
                                                onChange={e => setApiData({ ...apiData, status: e.target.value })}>
                                                <option value="">Select Status</option>
                                                <option value="Placed">Placed</option>
                                                <option value="Accepted">Accepted</option>
                                                <option value="Preparing">Preparing</option>
                                                <option value="Ready_For_Pickup">Ready_For_Pickup</option>
                                                <option value="Picked_Up">Picked_Up</option>
                                                <option value="Delivered">Delivered</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <select value={apiData.branch_id} className='form-select' 
                                                onChange={e => setApiData({ ...apiData, branch_id: e.target.value })} >
                                                <option value="">Select Branch</option>
                                                { branches.map((branch, index) => (
                                                    <option value={branch._id}>{branch.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <select value={apiData.type} className='form-select' 
                                                onChange={e => setApiData({ ...apiData, type: e.target.value })} >
                                                <option value=""> Order Type</option>
                                                <option value="pickup">Pickup</option>
                                                <option value="delivery">Delivery</option>
                                            </select>
                                        </div>
                                        
                                        <div className="col-md-3 mb-3">
                                            <select value={apiData.payment_method} className='form-select' 
                                                onChange={e => setApiData({ ...apiData, payment_method: e.target.value })} >
                                                <option value="">Pay Method</option>
                                                <option value="Card">Card</option>
                                                <option value="COD">COD</option>
                                                <option value="COP">COP</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <select value={apiData.order_from} className='form-select' 
                                                onChange={e => setApiData({ ...apiData, order_from: e.target.value })} >
                                                <option value="">Order From</option>
                                                <option value="App">App</option>
                                                <option value="Web">Web</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_orders_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Order #</th>
                                                <th>Branch</th>
                                                <th>User</th>
                                                <th>Pay Method</th>
                                                <th>Order Total</th>
                                                <th>Order Type</th>
                                                <th>Order From</th>
                                                <th>Status</th>
                                                <th>Payment Status</th>
                                                <th>Order Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {orders.length > 0 ? orders.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <Link to={`/orders/${item._id}`} className='text-gray-800 '>
                                                        #{item.order_code}
                                                        </Link>
                                                    </td>

                                                    <td>  {item.branch?.name}</td>
                                                    <td>
                                                        {item.user && 
                                                            <div>
                                                                {item.user.name} <br />
                                                                {item.user.phone}
                                                            </div>
                                                        }
                                                    </td>
                                                    <td> {item.payment_method}</td>
                                                    <td> {currency} {item.grand_total.toFixed(2)}</td>
                                                    <td> {item.type}</td>
                                                    <td> {item.order_from}</td>
                                                    <td>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span className={`badge bg-${statusColor[item.status]}`}  >
                                                                {item.status }
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span className={`badge bg-${statusColor[item.payment_status]}`}  >
                                                                {item.payment_status }
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td>  {formatDate(item.createdAt,'DD MMM YYYY, hh:mm A')} </td>
                                                    <td className="mt-2">
                                                        { selectStoredPermissions().includes('detail-orders') &&
                                                        <Link to={`/orders/${item._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-eye-fill fs-6"></i>
                                                        </Link>
                                                        }
                                                        { selectStoredPermissions().includes('delete-orders') &&
                                                            <button  onClick={() => delData(item._id)} className="btn btn-sm h-30px btn-light-primary">
                                                                <i className="bi bi-trash-fill fs-6"></i>
                                                            </button>
                                                        }
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2">No data found!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}
                                    <span>Total Records: {pagination?.total_records}</span>
                                    
                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
